import React from "react";
import { connect } from "react-redux";

import MaterialsWizardFooterSteps from "./materialsWizardFooterSteps";
import {isSameVisualizerWizard} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";

const getLastWizardItem = (allWizardsValues, activeQuoteIndex, wizardList) => {
  let wizardItem = null;
  let wizardValues = {};
  let wizardStep = 0;

  const currentQuoteWizards = allWizardsValues.filter(wizValue => wizValue.quoteIndex === activeQuoteIndex);
  let lastFinishedWizard = currentQuoteWizards.find(wizItem => {
    return wizItem.isLastActiveWizard && isSameVisualizerWizard(wizItem)
  });
  if (!lastFinishedWizard && currentQuoteWizards.length) {
    lastFinishedWizard = currentQuoteWizards[currentQuoteWizards.length - 1];
  }
  if (lastFinishedWizard) {
    wizardItem = wizardList.find(wizItem => wizItem.id === lastFinishedWizard.wizardItemId);
    if (wizardItem) {
      wizardValues = lastFinishedWizard.wizardSelectedValues;
      wizardStep = Number.isInteger(lastFinishedWizard.lastVisitedStep)
        ? lastFinishedWizard.lastVisitedStep
        : Object.keys(lastFinishedWizard.wizardSelectedValues).length;
    }
  }
  if (!wizardItem) {
    wizardItem = wizardList[0]; // this is for shopping cart page, to display at least something
  }
  return {wizardItem, wizardValues, wizardStep}
}

const ShoppingCartWizardFooterSteps = (props) => {

  const {wizardItem, wizardValues, wizardStep} = props;

  return <MaterialsWizardFooterSteps isShoppingCart={true}
                                     wizardItem={wizardItem}
                                     wizardValues={wizardValues}
                                     wizardStep={wizardStep}/>
};

const mapStateToProps = (store) => {
  const {allWizardsValues, wizardList} = store.wizardState;
  const {activeQuoteIndex} = store.quotesState;
  const {wizardItem, wizardValues, wizardStep} = getLastWizardItem(allWizardsValues, activeQuoteIndex, wizardList);
  return {
    wizardValues,
    wizardItem,
    wizardStep,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartWizardFooterSteps)
